import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';
import {environment} from "../../../environments/environment";

@Component({
    selector: 'races',
    templateUrl: './races.component.html'
})
export class RacesComponent implements OnInit {
    env = environment;

    raceActive=0;
    races=['elves','dwarfs'];
    currentRace=this.races[this.raceActive];

    constructor() { }

    ngOnInit() {
        this._setRace( Math.round(Math.random()*this.races.length) % this.races.length);
    }

    private _setRace(race) {
        this.raceActive =  this.mod(race, this.races.length);
        this.currentRace = this.races[this.raceActive];
        return;
    }

    selectRace(race) {
        for(var i=0; i < this.races.length; i++) {
            if(this.races[i] == race) {
                this._setRace(i);
                return;
            }
        }
    }

    nextRace() {
        this._setRace((this.raceActive+1) );
    }
    previousRace() {
        this._setRace((this.raceActive-1));
    }

    mod(n, m) {
        return ((n % m) + m) % m;
    }

}
